import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const Outcomes = () => {
  const { t } = useLang();
  const O = t.outcomes;

  const handleSchedule = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="outcomes"
      data-testid="outcomes-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="container-vel">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="overline mb-5" data-testid="outcomes-overline">
              {O.overline}
            </div>
            <h2
              data-testid="outcomes-heading"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl text-navy font-light leading-[1.05] tracking-tight"
            >
              {O.headline}.
            </h2>
          </motion.div>
        </div>

        <div
          data-testid="outcomes-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-navy/15"
        >
          {O.items.map((item, i) => (
            <motion.div
              key={item}
              data-testid={`outcome-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative border-b border-r border-navy/15 p-8 md:p-10 hover:bg-navy-50/40 transition-colors duration-500"
            >
              <div className="font-body text-xs font-semibold tracking-[0.22em] text-coral">
                {String(i + 1).padStart(2, "0")}
              </div>
              <p className="mt-4 font-heading text-xl sm:text-2xl text-navy font-medium leading-snug">
                {item}
              </p>
              <div className="absolute left-0 bottom-0 h-0.5 w-0 bg-coral transition-all duration-500 group-hover:w-full" />
            </motion.div>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <button
            data-testid="outcomes-cta-button"
            onClick={handleSchedule}
            className="group inline-flex items-center gap-2 bg-coral hover:bg-coral-600 text-white font-body text-sm font-medium tracking-wide px-7 py-4 rounded-sm transition-all duration-300 hover:-translate-y-0.5"
          >
            {O.cta}
            <ArrowRight
              size={16}
              strokeWidth={1.75}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </button>
          <p className="font-body text-sm text-ink-soft italic">
            {O.ctaFootnote}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Outcomes;
